import appGlobalScript from '/home/hudson/workspace/end_Stencil-JS_Deployment_master/src/global/global.ts';
export const globalScripts = appGlobalScript;
